// extracted by mini-css-extract-plugin
export default {"debtWidget":"DebtWidget_debtWidget__RQ9ao","debtWidgetTitle":"DebtWidget_debtWidgetTitle__SdHBv","debtWidgetAmount":"DebtWidget_debtWidgetAmount__+xwSu"};